
/*================================

Page Class

================================*/
export class Page {
    constructor(n) {
       this.cts;
       this.rightArea;
       this.leftArea;
       this.dir = n % 2 === 0 ? 'left' : 'right';
    }

    //外部ファイル読み込み
    load(url,elem) {
        const xhr      = new XMLHttpRequest(),
              method   = 'GET';

        //画像読み込み
        const loadIMG = (elem) => {
            const images = elem.querySelectorAll('img');
            let loadIMGNum = 0;
            for(let i = 0; i < images.length; i++){
                const img = images[i];
                const src = img.dataset.src;
                img.addEventListener('load',() => {
                    loadIMGNum++;
                    if(loadIMGNum >= images.length) {
                        const event = new Event('loadend');
                        elem.dispatchEvent(event);
                    }
                });

                img.src = src;
            }

        }
        xhr.responseType = 'document';
        xhr.open(method,url, true);

        xhr.addEventListener('readystatechange',() => {
            if(xhr.readyState === 4 && xhr.status === 200) {
                const response = xhr.responseXML;
                this.turnLeftArea = document.createElement('div');
                this.turnRightArea = document.createElement('div');
                this.contents = response.querySelector('.page');

                this.turnLeftArea.classList.add('turn-area','js-turn-area-left','turn-area--left');
                this.turnRightArea.classList.add('turn-area','js-turn-area-right','turn-area--right');
                this.contents.appendChild(this.turnLeftArea);
                this.contents.appendChild(this.turnRightArea);


                elem.innerHTML = this.contents.outerHTML;

                loadIMG(elem);

            }
        });
        xhr.send();
    }



    //コンテンツの中身を取得
    get contents() {
        return this.cts;

    }

    //コンテンツの中身を設定
    set contents(val) {
        this.cts = val;

    }

    get turnLeftArea() {
        return this.leftArea;
    }

    set turnLeftArea(val) {
        this.leftArea = val;
    }

    get turnRightArea() {
        return this.rightArea;
    }

    set turnRightArea(val) {
        this.rightArea = val;
    }
}

//module.exports = new Page();